import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

const StyledList = styled.ul`
  list-style-type: disc;
`;

const Box = styled.div`
  font-size: 18px !important;
  color: #000 !important;
  border: 3px solid #ff8f4e;
  border-radius: 10px;

  @media (max-width: 768px) {
    font-size: 14px !important;
  }
`;

const ATLTinckerpreneurObjective = ({ year }) => {
  const { t } = useTranslation();

  return (
    <div className="mt-md-2 row">
      <div className="col-md-12 mt-3">
        <Box className="w-100 p-3 p-md-5">
          <h2 className="text-center mb-2 mb-md-4">
            {t("atl_tinkerpreneur.about_title")}
          </h2>
          <div className="row">
            <div className="col-md-12">
              <div className="text-left">
                {year === 2026 ? (
                  <StyledList>
                    <li>{t("atl_tinkerpreneur_2026.about_content_1")}</li>
                    <li>{t("atl_tinkerpreneur_2026.about_content_2")}</li>
                    <li>{t("atl_tinkerpreneur_2026.about_content_3")}</li>
                    <li>{t("atl_tinkerpreneur_2026.about_content_4")}</li>
                  </StyledList>
                ) : (
                  t("atl_tinkerpreneur.about_content_1")
                )}
              </div>
            </div>
          </div>
        </Box>
      </div>
    </div>
  );
};

export default ATLTinckerpreneurObjective;
